export enum SummaryType {
  Preview = 'preview',
  About = 'about',
}
